/* eslint-disable import/prefer-default-export */
export enum PremiumLandingTab {
  Overview = 'overview',
  PremiumSessions = 'premium_sessions',
}
